import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Image,
  Input,
  Modal,
  Popconfirm,
  Table,
  Tooltip,
  Upload,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { GlobalVariables } from "../../resources/GlobalVariables";
import { AdminService } from "../../services/AdminService";
//import SliderBar from "./SliderBar";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
const BannerSlider = () => {
  const [initialRender, setInitialRender] = useState(true);
  const [slides, setSlides] = useState(null);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      AdminService.getSliders().then((data) => {
        setSlides(data.data);
      });
    }
  }, [initialRender]);
  const onFinish = (values) => {
    if (fileList.length < 1) {
      notification.error({
        message: "Error!",
        description: "Please add slider image",
      });
      return;
    }

    const req = {
      ...values,
      image: fileList[0].response.url,
    };
    console.log(req);
    AdminService.newSlide(req).then((data) => {
      notification.success({ message: "Success", description: "Slide added!" });
      form.resetFields();
      setFileList([]);
      setInitialRender(true);
    });
  };
  const uploadButton = (
    <div>
      <PlusOutlined style={{ fontSize: "26px" }} />
      <div className="ant-upload-text">Upload</div>
    </div>
  );

  const handleChangeImage = ({ file, fileList }) => {
    setFileList(fileList);
  };

  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  const deleteSlide = (id) => {
    AdminService.deleteSlide(id).then((data) => {
      notification.success({
        message: "Success",
        description: "Slide deleted!",
      });
      setInitialRender(true);
    });
  };
  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      render: (image) => (
        <Image
          src={process.env.REACT_APP_FILES_BASEURL + image}
          width="200px"
        />
      ),
    },
    {
      title: "Title",
      render: (item) => (
        <div>
          <p>{item.title}</p>
          <p>{item.titleTr}</p>
        </div>
      ),
    },
    {
      title: "Description",
      render: (item) => (
        <div>
          <p>{item.description}</p>
          <p>{item.descriptionTr}</p>
        </div>
      ),
    },
    {
      title: "Link",
      dataIndex: "url",
    },
    {
      title: "Actions",
      render: (item) => (
        <Tooltip title="Delete Slide" placement="left" key={item.id}>
          <Popconfirm
            title="Are you sure ?"
            onConfirm={() => deleteSlide(item.id)}
            okText="Yes! Delete."
            cancelText="Cancel"
          >
            <Button type="primary" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Tooltip>
      ),
    },
  ];
  return (
    <div className="max-w-5xl">
      <h1 className="text-red-600 text-2xl font-extrabold">Add new slide</h1>
      <Form form={form} {...GlobalVariables.formLayout} onFinish={onFinish}>
        <Form.Item label="Banner Image">
          <div className="clearfix">
            <Upload
              action={process.env.REACT_APP_API_BASEURL + "upload"}
              headers={{
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              }}
              listType="picture-card"
              fileList={fileList}
              onChange={handleChangeImage}
              onPreview={handlePreview}
            >
              {fileList.length >= 1 ? null : uploadButton}
            </Upload>
            <Modal
              visible={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={handleCancel}
            >
              <img alt="example" style={{ width: "100%" }} src={previewImage} />
            </Modal>
          </div>
        </Form.Item>
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input placeholder="Title" />
        </Form.Item>
        <Form.Item
          label="Başlık (TR)"
          name="titleTr"
          rules={[{ required: true }]}
        >
          <Input placeholder="Başlık" />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true }]}
        >
          <Input placeholder="Short Description" />
        </Form.Item>
        <Form.Item
          label="Açıklama (TR)"
          name="descriptionTr"
          rules={[{ required: true }]}
        >
          <Input placeholder="Kısa açıklama " />
        </Form.Item>
        <Form.Item
          name="url"
          label={`Click Path`}
          rules={[{ required: true, message: "Url required" }]}
        >
          <Input placeholder="Pleace type path only --> /news/2/details" />
        </Form.Item>
        <Form.Item {...GlobalVariables.tailLayout}>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
      <br />

      <h1 className="text-red-600 text-2xl font-extrabold">Preview slider</h1>

      {/* <SliderBar slides={slides} /> */}
      <br />
      <h1 className="text-red-600 text-2xl font-extrabold">Delete Slide</h1>
      <Table
        dataSource={slides}
        columns={columns}
        size="small"
        bordered
        rowKey="id"
      />
    </div>
  );
};

export default BannerSlider;
